var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: { name: "modal" },
      on: {
        "after-enter": function($event) {
          _vm.opened = true
        },
        leave: function($event) {
          _vm.opened = false
        }
      }
    },
    [
      _vm.visible
        ? _c(
            "div",
            {
              ref: "modal",
              staticClass: "modal",
              class: { scrollable: _vm.scrollable }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closeByOutside,
                      expression: "closeByOutside"
                    }
                  ],
                  ref: "content",
                  staticClass: "modal-content"
                },
                [
                  _vm._t("default"),
                  _c(
                    "div",
                    {
                      staticClass: "close-button",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.close($event)
                        }
                      }
                    },
                    [
                      _c("f-sprite-icon", {
                        attrs: { "icon-link": _vm.$options.icons.IconClose.id }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }